/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TagIcon16Light } from './TagIcon16Light';
import { TagIcon16Regular } from './TagIcon16Regular';
import { TagIcon16Solid } from './TagIcon16Solid';
import { TagIcon20Light } from './TagIcon20Light';
import { TagIcon20Regular } from './TagIcon20Regular';
import { TagIcon20Solid } from './TagIcon20Solid';
import { TagIcon24Regular } from './TagIcon24Regular';
import { TagIcon24Solid } from './TagIcon24Solid';
import { TagIcon32Regular } from './TagIcon32Regular';
import { TagIcon64Regular } from './TagIcon64Regular';
var sizes = {
    16: {
        light: TagIcon16Light,
        regular: TagIcon16Regular,
        solid: TagIcon16Solid,
    },
    20: {
        light: TagIcon20Light,
        regular: TagIcon20Regular,
        solid: TagIcon20Solid,
    },
    24: {
        regular: TagIcon24Regular,
        solid: TagIcon24Solid,
    },
    32: {
        regular: TagIcon32Regular,
    },
    64: {
        regular: TagIcon64Regular,
    },
};
export var TagIcon = forwardRef('TagIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
